import { Component } from '@builder.io/sdk';
import { AnchorField } from '../utils/commonFields';

const CTA = {
  name: 'cta',
  friendlyName: 'Action',
  type: 'object',
  required: true,
  subFields: [
    {
      name: 'label',
      type: 'text',
      required: true,
    },
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'secondary',
      enum: ['primary', 'secondary'],
      required: true,
    },
    {
      name: 'color',
      type: 'string',
      defaultValue: 'dark',
      enum: ['light', 'dark'],
      required: true,
    },
  ],
};

const successText = {
  friendlyName: 'Form Success Message',
  name: 'successText',
  type: 'string',
  required: true,
};

const Text = [
  {
    name: 'title',
    type: 'string',
    required: true,
  },
  {
    name: 'description',
    type: 'richText',
  },
];

const formComponents: { tabName: string; path: string; components: Record<string, Component> } = {
  tabName: 'Form Components',
  path: 'forms',
  components: {
    FinancingRequestForm: {
      name: 'FinancingRequestForm',
      inputs: [...Text, CTA, AnchorField, successText],
    },
    ContactUsForm: {
      name: 'ContactUsForm',
      inputs: [
        ...Text,
        CTA,
        {
          name: 'image',
          type: 'object',
          required: true,
          subFields: [
            {
              friendlyName: 'Alt Text',
              name: 'alt',
              type: 'string',
              required: true,
            },
            {
              name: 'url',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
              required: true,
            },
          ],
        },
        successText,
        AnchorField,
      ],
    },
    TrackOrderForm: {
      name: 'TrackOrderForm',
      inputs: [...Text, CTA, AnchorField],
    },
    EmailSignUpForm: {
      name: 'EmailSignUpForm',
      inputs: [...Text, CTA, AnchorField, successText],
    },
  },
};

export default formComponents;
